module.exports = __webpack_public_path__ + "static/media/iiw_heuschrecken_rundweg_stammersdorf.b231a27a.pdf";